<template>
  <div>
    <h3 class="fs-20 font-bold">Diving</h3>
    <ul class="my-6 grid-3 row-gap-4 list-reset">
      <li class="flex items-center"
        v-for="(incl, index) in displayingInclusions"
        :key="index">
        <div class="flex-none pr-3">
          <template v-if="incl.icon">
            <img width="28" height="28" :src="incl.icon" :alt="incl.name" />
          </template>
          <template v-else>
            <div style="width: 28px">
              <svg width="24" height="24">
                <use xlink:href="/img/sprite.svg#ic_success"></use>
              </svg>
            </div>
          </template>
        </div>
        <div class="flex-1">{{ incl.name }}</div>
      </li>
    </ul>

    <div class="mt-8" v-if="showPopup">
      <button class="btn btn-outlined btn-secondary input-tall sm:w-full"
        type="button"
        @click="$refs.moreModal.show()">
        View all {{ inclusions.length }} amenities
      </button>
      <zb-modal ref="moreModal" class="slide-in-modal">
        <h2 slot="title" class="fs-20 font-bold mb-6">Boat amenities</h2>
  
        <template v-slot:default>
          <div>
            <template v-if="included.length">
              <h5 class="font-bold my-3" v-if="included.length">Included</h5>
              <inclusion-sub-list :inclusions="included" />
            </template>

            <template v-if="notIncluded.length">
              <hr class="border border-black-30 my-6">
              <h5 class="font-bold my-3">Not Included</h5>
              <inclusion-sub-list :inclusions="notIncluded" />
            </template>

            <template v-if="extra.length">
              <hr class="border border-black-30 my-6">
              <h5 class="font-bold my-3">Additional cost</h5>
              <inclusion-sub-list :inclusions="extra" />
            </template>
          </div>
        </template>
      </zb-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import orderBy from "lodash/orderBy"
import get from "lodash/get"

import InclusionSubList from '../../components/core/InclusionSubList'
import { DIVE_CENTER_FACILITIES } from '../../helpers/constants'

export default {
  components: {
    InclusionSubList
  },
  computed: {
    ...mapState(['supplier']),
    inclusions() {
      return get(this.supplier, 'inclusions', [])
        .filter(incl => incl.list_id === DIVE_CENTER_FACILITIES)
    },
    orderedInclusions() {
      return orderBy(this.inclusions, ['order', 'name'], ['asc', 'asc'])
    },
    displayingInclusions () {
      return this.orderedInclusions
        .filter(incl => incl.type === 'included')
        .slice(0, 6)
    },
    included () {
      return this.orderedInclusions.filter(incl => incl.type === 'included')
    },
    extra () {
      return this.orderedInclusions.filter(incl => incl.type === 'extra')
    },
    notIncluded () {
      return this.orderedInclusions.filter(incl => incl.type === 'not_included')
    },
    showPopup () {
      return this.inclusions.some(incl => incl.type === 'extra' || incl.type === 'not_included')
        || (this.inclusions.length > this.displayingInclusions.length)
    }
  }
}
</script>
